export function FormField({ label, required, children }) {
  return (
    <div className="flex flex-col gap-2 sm:grid sm:grid-cols-[140px_1fr] sm:items-center sm:gap-4">
      {/* LABEL */}
      <label className="text-sm md:text-base font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {/* FIELD */}
      <div className="w-full">{children}</div>
    </div>
  );
}
